import { dateTemplate } from 'routes/Pages/GenTask/components/SharedFormFields';

export const docketColumnData = {
  loadingDetails: [
    { key: 'driverName', label: 'Driver', width: null },
    { key: 'loadedBy', label: 'Loaded By', width: null },
    { key: 'driverUserName', label: 'Entered By', width: null },
    { key: 'dateAndTime', label: 'Date and Time', width: null, formatter: dateTemplate },
    { key: 'docketId', label: 'Docket Id', width: null },
    { key: 'spNumber', label: 'SP Number', width: null },
    { key: 'truck', label: 'Truck', width: null },
    { key: 'productType', label: 'Product Type', width: null },
    { key: 'timberProductUsedForWoodchip', label: 'Product', width: null },
    { key: 'docketNumber', label: 'WH Docket Number', width: null },
    { key: 'name', label: 'Destination', width: null },
    { key: 'isLastLoad', label: 'Is Last Full Load', width: null },
    { key: 'supplierWeighbridgeGrWgt', label: 'Supplier Wt Gross', width: null },
    { key: 'supplierWeighbridgeNetWgt', label: 'Supplier Wt Net', width: null },
    { key: 'permitNumber', label: 'Permit Number', width: null },
    { key: 'supplierDocketNumber', label: 'Supplier Docket Number', width: null },
    { key: 'wH_Docket', label: 'WH Docket (Image)', width: null, isDocument: true },
    { key: 'permit', label: 'Permit (File/Image)', width: null, isDocument: true },
    { key: 'supplierDocket', label: 'Supplier Docket (File/Image)', width: null, isDocument: true },

    // { key: 'recordModifiedDate', label: 'Record Modified Date', width: null, formatter: dateTemplate },
  ],

  journeyDetails: [
    // { key: 'id', label: 'ID', width: null, primaryKey: true },
    { key: 'submissionDate', label: 'Submission Date', width: null, formatter: dateTemplate },
    // { key: 'docketNumber', label: 'Docket Number', width: null },
    { key: 'journeyDurationMins', label: 'Journey Duration (mins)', width: null },
    { key: 'journeyDistanceKm', label: 'Journey Distance (km)', width: null },
    { key: 'journeyFuelLit', label: 'Journey Fuel (litres)', width: null },
    { key: 'journeyLoadTonne', label: 'Journey Load (tonnes)', width: null },
    { key: 'job', label: 'Job', width: null },
    { key: 'name2', label: 'Name 2', width: null },
    { key: 'address', label: 'Address', width: null },
    { key: 'chargeableTravelTimetoJob', label: 'Chargeable Travel Time to Job', width: null },
    { key: 'startTimeOnSite', label: 'Start Time on Site', width: null },
    { key: 'chippingLoads', label: 'Chipping Loads', width: null },
    { key: 'loads', label: 'Loads', width: null },
    { key: 'totalVolume', label: 'Total Volume', width: null },
    { key: 'finishTimeOnSite', label: 'Finish Time on Site', width: null },
    { key: 'jobStartandEndTime', label: 'Job Start and End Time', width: null },
    { key: 'endKm', label: 'End KM', width: null },
    { key: 'totalKM', label: 'Total KM', width: null },
    { key: 'nonChargeableTime', label: 'Non-Chargeable Time', width: null },
    { key: 'chargableTravelTimeFromJob', label: 'Chargeable Travel Time from Job', width: null },
    { key: 'chargeableTime', label: 'Chargeable Time', width: null },
    { key: 'totalChargeableTime', label: 'Total Chargeable Time', width: null },
    { key: 'recordModifiedDate', label: 'Record Modified Date', width: null, formatter: dateTemplate },
  ],
  transfers: [
    // { key: 'id', label: 'ID', width: null, primaryKey: true },
    { key: 'submissionDate', label: 'Submission Date', width: null, formatter: dateTemplate },
    // { key: 'docketNumber', label: 'Docket Number', width: null },
    { key: 'transferToName', label: 'Transfer To Name', width: null },
    { key: 'transferToTruck', label: 'Transfer To Truck', width: null },
    { key: 'transferToEmail', label: 'Transfer To Email', width: null },
    { key: 'driverEmail', label: 'Driver Email', width: null },
    { key: 'distanceFromPickuptoDropoffPoint', label: 'Distance From Pickup to Dropoff Point', width: null },
    { key: 'transferToTrailer', label: 'Transfer To Trailer', width: null },
    { key: 'transferInformation', label: 'Transfer Information', width: null },
    { key: 'unloadingTruck', label: 'Unloading Truck', width: null },
    { key: 'unloadingTrailer', label: 'Unloading Trailer', width: null },
    { key: 'recordModifiedDate', label: 'Record Modified Date', width: null, formatter: dateTemplate },
  ],
  weighbridge: [
    // { key: 'id', label: 'ID', width: null, primaryKey: true },
    { key: 'submissionDate', label: 'Submission Date', width: null, formatter: dateTemplate },
    // { key: 'docketNumber', label: 'Docket Number', width: null },
    { key: 'customer', label: 'Customer', width: null },
    { key: 'weightBridge', label: 'Weighbridge', width: null },
    // { key: 'supplierWeighbridgeGrWgt', label: 'Supplier Weighbridge Gross Weight', width: null },
    // { key: 'supplierWeighbridgeNetWgt', label: 'Supplier Weighbridge Net Weight', width: null },
    { key: 'unloadingDetailsGrWgt', label: 'Unloading Details Gross Weight', width: null },
    { key: 'unloadingDetailsNetWgt', label: 'Unloading Details Net Weight', width: null },
    // { key: 'wH_Docket', label: 'WH Docket (Image)', width: null, isDocument: true },
    { key: 'weightbridgeDocketNumber', label: 'Weighbridge Docket Number', width: null },
    { key: 'wB_Docket', label: 'WB Docket (Image)', width: null, isDocument: true },
    // { key: 'permitNumber', label: 'Permit Number', width: null },
    // { key: 'permit', label: 'Permit (File/Image)', width: null, isDocument: true },
    // { key: 'supplierDocketNumber', label: 'Supplier Docket Number', width: null },
    // { key: 'supplierDocket', label: 'Supplier Docket (File/Image)', width: null, isDocument: true },
    { key: 'additionalInformation', label: 'Additional Information', width: null },
    { key: 'recordModifiedDate', label: 'Record Modified Date', width: null, formatter: dateTemplate },
  ],
};
